import * as React from "react";
import {cx} from "emotion";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleXmark, faSearch} from "@fortawesome/free-solid-svg-icons";

import "./orders-search.scss";

import {Types} from "@Common/types";

export const OrdersSearch = ({searchState, inputTip}: {searchState: Types.Common.React.UseState.UseStateNext<string>, inputTip: string}) => (
    <div className={cx({'search-input': true, 'active': searchState.value})}>
        <input
            onChange={(e) => searchState.onChange(e.target.value)}
            value={searchState.value}

            placeholder="Search"
            title={inputTip}
            xd-qa-type="textbox"
            xd-qa-name="Search"
        />
        <button
            onClick={(e) => searchState.value ? searchState.onChange("") : (e.currentTarget.previousSibling as HTMLInputElement).focus()}
            xd-qa-type="button"
            xd-qa-name={searchState.value ? "Clear" : "Search"}
            title={searchState.value ? "Clear" : "Search"}
        >
            <FontAwesomeIcon icon={searchState.value ? faCircleXmark : faSearch} xd-qa-type="icon" xd-qa-name={searchState.value ? "Clear" : "Search"}/>
        </button>
    </div>
);
